import { Divider, Steps } from 'antd'
import React from 'react'
import ModelComponent from '../../../components/Modal'

const TrackOrder = ({ modalShow, setModalShow }) => {
  return (
    <ModelComponent
      show={modalShow?.show}
      modalsize={'lg'}
      className='modal-backdrop'
      modalheaderclass={''}
      modeltitle={'Tracking details'}
      onHide={() => {
        setModalShow({ show: !modalShow?.show, data: null })
      }}
      btnclosetext={''}
      closebtnvariant={''}
      backdrop={'static'}
    >
      <Divider />
      <Steps
        progressDot
        current={modalShow?.data?.length}
        direction='vertical'
        items={modalShow?.data?.map((item) => {
          return {
            title: `Order stage: ${item?.orderStage}`,
            description: `Order status: ${item?.orderStatus}`
          }
        })}
      />
    </ModelComponent>
  )
}

export default TrackOrder
